<div class="container d-flex pt-lg-5 pt-4">
  <div class="card border-disabled mx-auto mt-lg-5">
    <div class="card-body text-center py-4 border-0">
      <div class="d-flex align-items-center justify-content-center mb-3">
        <span class="credit-card-icon icon material-icons me-3" aria-hidden="true">add_card</span>
        <span class="card-heading text-success">{{ 'ecash.successful.page.heading' | translate }}</span>
      </div>

      <hr class="horizontal-line mb-4" />

      <p class="font-size-14 mt-4 mb-0 pt-2">{{ 'redbulls.pay.success.message' | translate }}</p>
      <div class="btn-container mt-3 d-block">
        <button [routerLink]="['/ecash']" type="button" class="btn btn-primary mx-2 mt-3 btn-text fw-bold px-5">
          {{ 'back.to.payment.btn' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
